<template>
  <i
    v-b-tooltip.html.hover.viewport.noninteractive
    class="bi bi-info-circle pointer"
    :title="`<div class='text-left'>
      <b>To apply updates across templates:</b>
      <ol class='pl-3 m-0'>
        <li>Select the destination templates</li>
        <li>Select the ${actionsText}</li>
        <li>Click Apply</li>
      </ol>
    </div>`"
  />
</template>

<script>
export default {
  name: 'ApplyInfoButton',
  props: {
    actionsText: {
      type: String,
      default: 'actions'
    },
  },
}
</script>
